import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { API_URL } from '../utils/apiUrl';

if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not set');
}

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
// Only redirect to login for admin pages, not for public API calls
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      // Only redirect if user is on an admin page and not already on login page
      // Also exclude the login API call itself from redirect
      const isLoginRequest = error.config?.url?.includes('/api/admin/login');
      if (currentPath.startsWith('/admin') && currentPath !== '/admin/login' && !isLoginRequest) {
        localStorage.removeItem('access_token');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
